import { useEffect, useState } from 'react';

import { db } from 'src/utils/firebase'; // Adjust the import path based on your file structure

function useAccounts(userId, liabilities) {
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    if (!userId) {
      setAccounts([]);
      return () => {};
    }

    const unsubscribe = db
      .collection('accounts')
      .where('user_id', '==', userId)
      .limit(100)
      .onSnapshot((snapshot) => {
        // First, get all accounts
        const allAccounts = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Find the first checking account
        const primaryAccountId = allAccounts.find((acc) => acc.subtype === 'checking')?.id;

        // Map through accounts and add additional properties
        const fetchedAccounts = allAccounts.map((account) => ({
          ...account,
          is_primary: account.id === primaryAccountId,
          missing_liability:
            (account.type === 'loan' || account.subtype === 'loan') &&
            !liabilities.some((e) => e.account_id === account.id),
        }));

        setAccounts(fetchedAccounts);
      });

    return () => unsubscribe();
  }, [userId, liabilities]);

  return accounts;
}

export default useAccounts;
